import axios from "axios";
import { Toast } from "vant";
import Router from "../router";
import store from "../store/Store";

// 创建axios实例
const service = axios.create({
    // baseURL: process.env.BASE_API, // api的base_url
    baseURL: 'https://wztech.net.cn:20001/apis',
    //   baseURL: 'https://serverapi.mdxc.gdcbd.net/apis',
    timeout: 15000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
    config => {
        Toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0
        });
        if (store.state.token) {
            config.headers["token"] = store.state.token; // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        config.headers["appType"] = "AGENT";
        let { headers = {}, isFormData = false } = config;
        if (config.method === "get") {
            // 过滤掉没有值的属性
            let params = {};
            for (let key in config.params) {
                if (config.params[key]) {
                    params[key] = config.params[key];
                }
            }
            config.params = params;
        }
        const newOptions = { ...config };
        if (isFormData) {
            newOptions.headers = { ...headers };
            newOptions.data = toFormData(newOptions.data);

            if (
                newOptions.method === "post" ||
                newOptions.method === "put" ||
                newOptions.method === "delete"
            ) {
                if (!(newOptions.data instanceof FormData)) {
                    newOptions.headers = {
                        "Content-Type": "application/json; charset=utf-8",
                        ...newOptions.headers
                    };
                    newOptions.data = JSON.stringify(newOptions.data);
                } else {
                    // newOptions.body is FormData
                    newOptions.headers = {
                        // 'Content-Type': 'multipart/form-data',
                        ...newOptions.headers
                    };
                }
            }
        }
        return newOptions;
    },
    error => {
        // Do something with request error
        console.error(error); // for debug
        Promise.reject(error);
    }
);

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * statusCode为非200是抛错 可结合自己业务进行修改
         */
        Toast.clear();
        const res = response.data;
        if (res.statusCode !== 200) {
            Toast.fail(res.msg);
            // 401:未登录;
            if (
                res.statusCode === 401 ||
                res.statusCode === 408 ||
                res.statusCode === -1
            ) {
                store.commit("SET_TOKEN", null);
                Router.replace("/login");
                return;
            }
            return Promise.reject(response.data);
        } else {
            return response.data.result;
        }
    },
    error => {
        Toast.clear();
        console.error(error); // for debug
        // 401:未登录;
        if (
            error.request.statusCode === 401 ||
            error.request.statusCode === 408
        ) {
            store.commit("SET_TOKEN", null);
            Router.replace("/login");
        }
        let message = JSON.parse(error.request.response).msg;
        Toast.fail(message);
        return Promise.reject(error);
    }
);

export default service;

export function toFormData(params) {
    let form = new FormData();

    let keys = Object.keys(params);

    for (let key of keys) {
        form.append(key, params[key]);
    }

    return form;
}



// WEBPACK FOOTER //
// ./src/utils/request.js